var styleDataHash = "8fc37992";
const injectCss = (() => {
  var css = `._0VRo2{background-color:unset;--wsr-color-D10-66:rgba(0,0,0,.5)}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var settings_modal_default = {
  "imageViewer": "_0VRo2"
};
export {
  settings_modal_default as default,
  injectCss
};
//# sourceMappingURL=settings-modal-scss.js.map
